/*
  FSO Çocukluk Posteri stüdyosu — "Çocukluğumuz" ürünü (product-information art_engine = cocukluk).

  Müşteri iki kişinin çocukluk fotoğrafını yükler, iki ismi yazar, bir söz seçer (ya da kendisi yazar):
  → fotoğraflar tarayıcıda yüze göre kırpılıp küçültülür (MediaPipe; yüz yoksa olduğu gibi)
  → sunucu (portre.forspaceon.com/cocuk/…) iki fotoğraftan "sarılan iki çocuk" görselini üretir, arka planını siler (~30–40 sn)
  → poster tarayıcıda dizilir: kesik kağıt harfli isimler, kalpli çizgi, söz, beyaz kenarlı çıkartma (isimler değişince anında)
  → "Tekrar dene" yeni bir görsel üretir; önceki denemeler küçük resimlerden seçilebilir
  → sepete eklerken poster tam çözünürlükte (2400×3491, 33:48) JPEG olarak gönderilir, sunucu 33×48 cm PDF yapar;
    sipariş satırına gizli özellikler yazılır: _tasarim_pdf, _tasarim_onizleme, _isimler, _soz.

  Tasarımlar (ayar.tasarim; aynı sarılma görseli, farklı poster ve giriş alanları):
    klasik — kesik kağıt harfli iki isim + kalpli çizgi + söz (Biz Daha Çocukken)
    pastel — çocuk defteri çizimleri (güneş, bulut, ev, kalpler), rengârenk eğri harflerle iki isim
    sarki  — müzik çalar ekranı: sarılma görseli kapak; Spotify linkinden şarkı adı, süre ve Spotify kodu (sunucu /spotify);
             sanatçı adı Spotify'dan ya da müşterinin yazdığı
    dogum  — bayraklar, konfeti, "iyi ki doğdun" + isim; parti şapkaları yüz algılamayla çocukların başına yerleşir

  Kurulum: <div data-fso-cocuk><script type="application/json" data-fso-cocuk-ayar>{...}</script></div>
  Ayarlar: api, tasarim, form, medya, galeri, renk, kok, kvkk, sozler [..], metinler {..}
*/
(function () {
  'use strict';

  /* ---------- Yüz algılama (fotoğrafı ana yüze göre kırpmak için) ---------- */
  var MP_SURUM = '0.10.14';
  var algilayiciSozu = null;
  function algilayici() {
    if (!algilayiciSozu) {
      algilayiciSozu = (async function () {
        var vision = await import('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@' + MP_SURUM + '/vision_bundle.mjs');
        var dosyalar = await vision.FilesetResolver.forVisionTasks('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@' + MP_SURUM + '/wasm');
        return vision.FaceDetector.createFromOptions(dosyalar, {
          baseOptions: { modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite' },
          runningMode: 'IMAGE',
          minDetectionConfidence: 0.5,
        });
      })();
      algilayiciSozu.catch(function () { algilayiciSozu = null; });
    }
    return algilayiciSozu;
  }
  function zamanAsimi(soz, ms) {
    return Promise.race([soz, new Promise(function (_, red) { setTimeout(function () { red(new Error('zaman aşımı')); }, ms); })]);
  }

  // Fotoğraf → en büyük yüzün çevresi (omuzlar dahil), en fazla 1024 px JPEG data URL. Arka plandaki başka kişiler kırpılır.
  async function fotoHazirla(dosya) {
    var url = URL.createObjectURL(dosya);
    var img = new Image();
    img.src = url;
    await img.decode();
    var fw = img.naturalWidth, fh = img.naturalHeight;
    var kx = 0, ky = 0, kw = fw, kh = fh;
    try {
      var fd = await zamanAsimi(algilayici(), 15000);
      var yuzler = (fd.detect(img).detections || []).map(function (d) { return d.boundingBox; });
      if (yuzler.length) {
        var b = yuzler.sort(function (a, c) { return c.width * c.height - a.width * a.height; })[0];
        var cx = b.originX + b.width / 2, cy = b.originY + b.height / 2;
        kw = Math.min(fw, b.width * 3.4);
        kh = Math.min(fh, kw * 1.3);
        kx = Math.max(0, Math.min(fw - kw, cx - kw / 2));
        ky = Math.max(0, Math.min(fh - kh, cy - kh * 0.38));
      }
    } catch (e) {
      console.warn('[cocukluk] yüz algılama çalışmadı, fotoğraf olduğu gibi kullanılıyor', e);
    }
    var o = Math.min(1, 1024 / Math.max(kw, kh));
    var c = document.createElement('canvas');
    c.width = Math.round(kw * o); c.height = Math.round(kh * o);
    var ctx = c.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, kx, ky, kw, kh, 0, 0, c.width, c.height);
    return { veri: c.toDataURL('image/jpeg', 0.9), url: url };
  }

  /* ---------- Poster dizgisi (poster 33:48; tüm ölçüler 1100 genişliğe göre, k ile ölçeklenir) ---------- */
  var YAZI_TIPLERI = ['Bungee', 'Rubik Mono One', 'Abril Fatface', 'Titan One', 'Shrikhand', 'Alfa Slab One', 'Chango', 'Righteous'];
  var KAGIT = ['#F9A8D4', '#BAE6FD', '#D9F99D', '#C4B5FD', '#FDE68A', '#E7D7C1', '#FBCFE8', '#A7F3D0', '#FED7AA', '#E5E7EB'];
  var MUREKKEP = ['#7C3AED', '#DB2777', '#166534', '#1D4ED8', '#B91C1C', '#111111', '#C2410C', '#0F766E'];
  var ACI = [-6, 4, -3, 7, -5, 3, -2, 6, -7, 2];
  var KUCUK_HARF = 'AEFGHİNRTY';
  var CIZGI = new Path2D('M -10 120 C 120 150, 250 70, 380 110 C 470 138, 510 150, 548 128 C 520 100, 470 70, 470 38 C 470 8, 510 -2, 534 22 C 545 33, 550 44, 550 52 C 550 44, 556 33, 567 22 C 591 -2, 631 8, 631 38 C 631 70, 580 100, 552 128 C 590 150, 630 138, 720 110 C 850 70, 980 150, 1110 120');
  var KALP = new Path2D('M50 88 C20 66 6 50 6 32 C6 17 18 7 31 7 C40 7 46 12 50 19 C54 12 60 7 69 7 C82 7 94 17 94 32 C94 50 80 66 50 88 Z');
  var yaziSozu = null;

  function yaziTipleriniYukle() {
    if (!yaziSozu) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Alfa+Slab+One&family=Bungee&family=Chango&family=Righteous&family=Rubik+Mono+One&family=Shrikhand&family=Titan+One&family=Patrick+Hand&family=Gochi+Hand&family=Fredoka:wght@600&family=Figtree:wght@400;700&display=swap';
      document.head.appendChild(l);
      yaziSozu = new Promise(function (tamam) { l.onload = tamam; l.onerror = tamam; }).then(function () {
        var ornek = 'ABCÇĞİÖŞÜabcçğıöşü';
        var tipler = YAZI_TIPLERI.concat(['Patrick Hand', 'Gochi Hand']).map(function (f) { return '40px "' + f + '"'; })
          .concat(['600 40px "Fredoka"', '400 40px "Figtree"', '700 40px "Figtree"']);
        return Promise.all(tipler.map(function (f) { return document.fonts.load(f, ornek).catch(function () {}); }));
      });
    }
    return yaziSozu;
  }

  function harfDizisi(ad) {
    return Array.from(String(ad || '').toLocaleUpperCase('tr').replace(/\s+/g, ' ').trim()).slice(0, 12);
  }

  function klasikCiz(cv, d) {
    var W = cv.width, H = cv.height, k = W / 1100;
    var ctx = cv.getContext('2d');
    var zemin = ctx.createLinearGradient(0, 0, 0, H);
    zemin.addColorStop(0, '#F2F1EE');
    zemin.addColorStop(1, '#ECEBE7');
    ctx.fillStyle = zemin;
    ctx.fillRect(0, 0, W, H);

    // İsimler: kesik kağıt harfler + ortada kırmızı kalp
    var h1 = harfDizisi(d.ad1), h2 = harfDizisi(d.ad2);
    var olcu = 96, karo = 128, aralik = 6, kalp = 118, bosluk = 18;
    function karolar(o) {
      ctx.save();
      var liste = [], sira = 0;
      function ekle(harfler) {
        harfler.forEach(function (h) {
          if (h === ' ') { liste.push({ bosluk: true }); return; }
          var yazi = (sira % 3 === 1 && KUCUK_HARF.indexOf(h) >= 0) ? h.toLocaleLowerCase('tr') : h;
          var tip = YAZI_TIPLERI[(sira * 3 + 2) % YAZI_TIPLERI.length];
          ctx.font = (olcu * o * k) + 'px "' + tip + '"';
          var en = Math.max(84 * o * k, ctx.measureText(yazi).width + 24 * o * k);
          liste.push({ yazi: yazi, tip: tip, en: en, kagit: KAGIT[(sira * 3) % KAGIT.length], renk: MUREKKEP[(sira * 5 + 1) % MUREKKEP.length], aci: ACI[sira % ACI.length], kay: (sira % 2) ? 4 : -4 });
          sira++;
        });
      }
      ekle(h1);
      liste.push({ kalp: true, en: (kalp + 16) * o * k });
      ekle(h2);
      ctx.restore();
      return liste;
    }
    var o = 1, liste = karolar(1);
    var toplam = function (l, oo) { return l.reduce(function (t, x) { return t + (x.bosluk ? bosluk * oo * k : x.en) + aralik * oo * k; }, 0); };
    var genis = toplam(liste, 1);
    if (genis > W * 0.9) { o = (W * 0.9) / genis; liste = karolar(o); genis = toplam(liste, o); }
    var x = (W - genis) / 2, ust = 140 * k + (karo * (1 - o) * k) / 2, y0 = ust + (karo * o * k) / 2;
    liste.forEach(function (t) {
      if (t.bosluk) { x += (bosluk + aralik) * o * k; return; }
      if (t.kalp) {
        var s = (kalp * o * k) / 100;
        ctx.save();
        ctx.translate(x + 8 * o * k, y0 - (kalp * o * k) / 2);
        ctx.scale(s, s);
        ctx.shadowColor = 'rgba(0,0,0,0.25)'; ctx.shadowOffsetX = 1; ctx.shadowOffsetY = 2; ctx.shadowBlur = 2;
        ctx.fillStyle = '#D7261E';
        ctx.fill(KALP);
        ctx.restore();
        x += t.en + aralik * o * k;
        return;
      }
      var hk = karo * o * k;
      ctx.save();
      ctx.translate(x + t.en / 2, y0 + t.kay * o * k);
      ctx.rotate((t.aci * Math.PI) / 180);
      ctx.shadowColor = 'rgba(0,0,0,0.25)'; ctx.shadowOffsetX = 1 * k; ctx.shadowOffsetY = 2 * k; ctx.shadowBlur = 3 * k;
      ctx.fillStyle = t.kagit;
      ctx.fillRect(-t.en / 2, -hk / 2, t.en, hk);
      ctx.shadowColor = 'transparent';
      ctx.fillStyle = t.renk;
      ctx.font = (olcu * o * k) + 'px "' + t.tip + '"';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(t.yazi, 0, 4 * o * k);
      ctx.restore();
      x += t.en + aralik * o * k;
    });

    // Kalpli çizgi
    ctx.save();
    ctx.translate(0, 400 * k);
    ctx.scale(k, k);
    ctx.strokeStyle = '#111111';
    ctx.lineWidth = 7;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.stroke(CIZGI);
    ctx.restore();

    // Söz (gerekirse iki satır)
    if (d.soz) {
      ctx.save();
      ctx.fillStyle = '#1A1A1A';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';
      var boy = 40;
      var metin = '“' + d.soz + '”';
      ctx.font = (boy * k) + 'px "Patrick Hand"';
      var azami = W - 160 * k;
      var satirlar = [metin];
      if (ctx.measureText(metin).width > azami) {
        var kel = metin.split(' '), a = '', b2 = [];
        kel.forEach(function (w) { var dene = a ? a + ' ' + w : w; if (ctx.measureText(dene).width > azami && a) { b2.push(a); a = w; } else { a = dene; } });
        if (a) b2.push(a);
        satirlar = b2.slice(0, 2);
      }
      satirlar.forEach(function (s, i) { ctx.fillText(s, W / 2, 590 * k + i * boy * 1.25 * k); });
      ctx.restore();
    }

    // Çıkartma (alt orta) ya da yer tutucu
    cikartmaYerlestir(ctx, W, H, k, d, 640, 720);
  }

  // Çıkartmayı alt ortaya oturtur (en: 1100'lük genişlikte azami en; ustSinir: üstte boş kalacak yükseklik).
  // Çıkartma yoksa kesik çizgili yer tutucu çizer. Döner: çıkartmanın postere çizildiği konum ve ölçek (şapkalar için).
  function cikartmaYerlestir(ctx, W, H, k, d, en, ustSinir) {
    var gw = en * k;
    if (d.cikartma) {
      var gh = gw * (d.cikartma.height / d.cikartma.width);
      if (gh > H - ustSinir * k) { gh = H - ustSinir * k; gw = gh * (d.cikartma.width / d.cikartma.height); }
      var x = (W - gw) / 2, y = H - gh;
      ctx.save();
      ctx.shadowColor = 'rgba(0,0,0,0.12)'; ctx.shadowOffsetY = 6 * k; ctx.shadowBlur = 12 * k;
      ctx.drawImage(d.cikartma, x, y, gw, gh);
      ctx.restore();
      return { x: x, y: y, olcek: gw / d.cikartma.width };
    }
    var yh = Math.min(760 * k, H - ustSinir * k - 40 * k), yx = (W - gw) / 2, yy = H - yh - 40 * k;
    ctx.save();
    ctx.setLineDash([16 * k, 12 * k]);
    ctx.strokeStyle = '#B9B4AA';
    ctx.lineWidth = 3 * k;
    ctx.strokeRect(yx, yy, gw, yh);
    ctx.setLineDash([]);
    ctx.fillStyle = '#8A857C';
    ctx.font = '600 ' + (30 * k) + 'px system-ui, sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText(d.yerTutucu || '', W / 2, yy + yh / 2);
    ctx.restore();
    return null;
  }

  // Yazıyı verilen genişliğe sığdırır: önce yazı boyunu küçültür (en az asgari), yine sığmazsa sonunu "…" ile keser
  function sigdir(ctx, metin, agirlik, boy, asgari, aile, azami) {
    var b = boy;
    ctx.font = agirlik + ' ' + b + 'px ' + aile;
    while (ctx.measureText(metin).width > azami && b > asgari) { b -= 1; ctx.font = agirlik + ' ' + b + 'px ' + aile; }
    if (ctx.measureText(metin).width > azami) {
      var kes = Array.from(metin);
      while (kes.length && ctx.measureText(kes.join('') + '…').width > azami) kes.pop();
      metin = kes.join('').trim() + '…';
    }
    return metin;
  }

  /* ---------- Pastel boya: çocuk defteri çizimleri (yollar 100 × 145 birimlik posterde) ---------- */
  var PASTEL_RENK = ['#E5484D', '#F28C28', '#45A54A', '#2F80ED', '#9A5BD8'];
  var PASTEL_CIZIM = [
    ['M91 38a7 7 0 1 1-14 0a7 7 0 1 1 14 0', '#F6B21A', 1.7],
    ['M84 27.5v-4M84 52.5v-4M73.5 38h-4M98.5 38h-4M76.5 30.5l-3-3M91.5 45.5l3 3M91.5 30.5l3-3M76.5 45.5l-3 3', '#F6B21A', 1.4],
    ['M8 40c2-4 7-4 9-1 2-3 8-3 9 1 3 0 4 4 1 5H9c-3 0-4-3-1-5z', '#68B4E8', 1.4],
    ['M42 29c1.5-3 5-3 6.5-.5 1.5-2 5.5-2 6.5.8 2 0 3 3 .7 3.7H43c-2 0-3-2.4-1-4z', '#68B4E8', 1.1],
    ['M5 141c3-4 5-4 6 0 2-5 4-5 6 0 2-4 4-4 6 0M77 141c3-4 5-4 6 0 2-5 4-5 6 0 2-4 4-4 6 0', '#45A54A', 1.5],
    ['M9 92c-1-3 3-5 4-2 1-3 5-1 4 2-1 3-4 4-4 4s-3-1-4-4zM85 84c-1-3 3-5 4-2 1-3 5-1 4 2-1 3-4 4-4 4s-3-1-4-4z', '#E5484D', 1.4],
    ['M91 104c-.7-2 2-3.4 2.7-1.4.7-2 3.4-.7 2.7 1.4-.7 2-2.7 2.7-2.7 2.7s-2-.7-2.7-2.7z', '#F28C28', 1.1],
    ['M9 122v-12l7-7 7 7v12zM14 122v-6h4v6', '#9A5BD8', 1.4],
    ['M6 60l1.6 3.4 3.7.5-2.7 2.6.7 3.7-3.3-1.8-3.3 1.8.7-3.7L1.3 63.9l3.7-.5z', '#F6B21A', 1.1],
  ].map(function (c) { return { yol: new Path2D(c[0]), renk: c[1], en: c[2] }; });

  // Pastel boya çizgisi: aynı yol hafif kaydırılarak üç kez, yarı saydam çizilir (mum boya dokusu)
  function kalemCiz(ctx, s, c) {
    [[0, 0, 1, 0.75], [0.22, -0.18, 0.75, 0.5], [-0.2, 0.2, 0.85, 0.45]].forEach(function (g) {
      ctx.save();
      ctx.scale(s, s);
      ctx.translate(g[0], g[1]);
      ctx.globalAlpha = g[3];
      ctx.strokeStyle = c.renk;
      ctx.lineWidth = c.en * g[2];
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.stroke(c.yol);
      ctx.restore();
    });
  }

  function pastelCiz(cv, d) {
    var W = cv.width, H = cv.height, k = W / 1100, s = W / 100;
    var ctx = cv.getContext('2d');
    ctx.fillStyle = '#FFFEFB';
    ctx.fillRect(0, 0, W, H);
    PASTEL_CIZIM.forEach(function (c) { kalemCiz(ctx, s, c); });

    // İsimler: her harf ayrı renk ve açıyla, ortada kırmızı kalp
    var harfler = harfDizisi(d.ad1).concat([' ', '♥', ' ']).concat(harfDizisi(d.ad2));
    var boy = 140 * k;
    var olc = function (b) {
      ctx.font = b + 'px "Gochi Hand"';
      return harfler.map(function (h) { return h === '♥' ? b * 0.9 : (h === ' ' ? b * 0.22 : ctx.measureText(h).width + b * 0.04); });
    };
    var enler = olc(boy), toplam = enler.reduce(function (a, b) { return a + b; }, 0);
    if (toplam > W * 0.88) { boy = boy * (W * 0.88) / toplam; enler = olc(boy); toplam = enler.reduce(function (a, b) { return a + b; }, 0); }
    var x = (W - toplam) / 2, y = 150 * k, renkSira = 0;
    harfler.forEach(function (h, i) {
      var en = enler[i];
      if (h === '♥') {
        var ks = (boy * 0.72) / 100;
        ctx.save();
        ctx.translate(x + en / 2 - 50 * ks, y - 50 * ks);
        ctx.scale(ks, ks);
        ctx.fillStyle = '#E5484D';
        ctx.fill(KALP);
        ctx.restore();
      } else if (h !== ' ') {
        ctx.save();
        ctx.translate(x + en / 2, y);
        ctx.rotate((ACI[i % ACI.length] * Math.PI) / 180);
        ctx.fillStyle = PASTEL_RENK[renkSira++ % PASTEL_RENK.length];
        ctx.font = boy + 'px "Gochi Hand"';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(h, 0, 0);
        ctx.restore();
      }
      x += en;
    });

    cikartmaYerlestir(ctx, W, H, k, d, 814, 400);
  }

  /* ---------- Bizim şarkımız: müzik çalar ekranı + Spotify kodu ---------- */
  var IKON = {
    karisik: new Path2D('M3 7h4l10 10h4M3 17h4l3-3M14 10l3-3h4M18 4l3 3-3 3M18 14l3 3-3 3'),
    geri: new Path2D('M6 6v12M18 6l-9 6 9 6z'),
    ileri: new Path2D('M18 6v12M6 6l9 6-9 6z'),
    tekrar: new Path2D('M17 2l3 3-3 3M4 11V9a4 4 0 0 1 4-4h12M7 22l-3-3 3-3M20 13v2a4 4 0 0 1-4 4H4'),
  };
  var sureYaz = function (ms) { var t = Math.round((ms || 0) / 1000); return Math.floor(t / 60) + ':' + String(t % 60).padStart(2, '0'); };

  function sarkiCiz(cv, d) {
    var W = cv.width, H = cv.height, k = W / 1100;
    var ctx = cv.getContext('2d');
    var zemin = ctx.createLinearGradient(0, 0, 0, H);
    zemin.addColorStop(0, '#D8D1C6');
    zemin.addColorStop(0.62, '#F2EFEA');
    zemin.addColorStop(1, '#F2EFEA');
    ctx.fillStyle = zemin;
    ctx.fillRect(0, 0, W, H);

    // Kapak: sarılma görseli (arka planıyla), kare, yuvarlak köşe
    var ks = 800 * k, kx = (W - ks) / 2, ky = 100 * k, r = 34 * k;
    ctx.save();
    ctx.shadowColor = 'rgba(60,40,20,0.35)'; ctx.shadowOffsetY = 24 * k; ctx.shadowBlur = 50 * k;
    ctx.fillStyle = '#E4DED4';
    ctx.beginPath();
    if (ctx.roundRect) ctx.roundRect(kx, ky, ks, ks, r); else ctx.rect(kx, ky, ks, ks);
    ctx.fill();
    ctx.restore();
    if (d.kapak) {
      var iw = d.kapak.naturalWidth || d.kapak.width, ih = d.kapak.naturalHeight || d.kapak.height, kenar = Math.min(iw, ih);
      ctx.save();
      ctx.beginPath();
      if (ctx.roundRect) ctx.roundRect(kx, ky, ks, ks, r); else ctx.rect(kx, ky, ks, ks);
      ctx.clip();
      ctx.drawImage(d.kapak, (iw - kenar) / 2, (ih - kenar) * 0.18, kenar, kenar, kx, ky, ks, ks);
      ctx.restore();
    } else {
      ctx.save();
      ctx.fillStyle = '#8A857C';
      ctx.font = '600 ' + (30 * k) + 'px system-ui, sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText(d.yerTutucu || '', W / 2, ky + ks / 2);
      ctx.restore();
    }

    // Şarkı adı + sanatçı + kalp
    var sol = 150 * k, sag = W - 150 * k, sarki = d.sarki || {};
    ctx.save();
    ctx.fillStyle = '#141414';
    ctx.textBaseline = 'alphabetic';
    var baslik = sigdir(ctx, sarki.ad || d.sarkiOrnek || '', '700', 64 * k, 44 * k, '"Figtree", sans-serif', sag - sol - 90 * k);
    ctx.fillText(baslik, sol, 990 * k);
    ctx.fillStyle = '#6A645B';
    var sanatci = sigdir(ctx, d.sanatci || '', '400', 40 * k, 30 * k, '"Figtree", sans-serif', sag - sol - 90 * k);
    ctx.fillText(sanatci, sol, 1048 * k);
    var kalpOlcek = (62 * k) / 100;
    ctx.translate(sag - 62 * k, 948 * k);
    ctx.scale(kalpOlcek, kalpOlcek);
    ctx.fillStyle = '#D7263D';
    ctx.fill(KALP);
    ctx.restore();

    // İlerleme çubuğu ve süreler (çalan an süreyle orantılı: %36)
    var by = 1108 * k, oran = 0.36, bx = sol + (sag - sol) * oran;
    ctx.save();
    ctx.lineCap = 'round';
    ctx.lineWidth = 10 * k;
    ctx.strokeStyle = '#CFC8BD';
    ctx.beginPath(); ctx.moveTo(sol, by); ctx.lineTo(sag, by); ctx.stroke();
    ctx.strokeStyle = '#141414';
    ctx.beginPath(); ctx.moveTo(sol, by); ctx.lineTo(bx, by); ctx.stroke();
    ctx.fillStyle = '#141414';
    ctx.beginPath(); ctx.arc(bx, by, 15 * k, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = '#6A645B';
    ctx.font = '400 ' + (30 * k) + 'px "Figtree", sans-serif';
    ctx.textBaseline = 'top';
    ctx.textAlign = 'left';
    ctx.fillText(sarki.sureMs ? sureYaz(sarki.sureMs * oran) : '0:00', sol, by + 26 * k);
    ctx.textAlign = 'right';
    ctx.fillText(sarki.sureMs ? sureYaz(sarki.sureMs) : '-:--', sag, by + 26 * k);
    ctx.restore();

    // Çalar düğmeleri
    var cy = 1262 * k, ik = (58 * k) / 24;
    var ikonCiz = function (yol, cx, dolu) {
      ctx.save();
      ctx.translate(cx - 12 * ik, cy - 12 * ik);
      ctx.scale(ik, ik);
      ctx.strokeStyle = '#141414'; ctx.fillStyle = '#141414';
      ctx.lineWidth = 1.9; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      if (dolu) ctx.fill(yol);
      ctx.stroke(yol);
      ctx.restore();
    };
    ikonCiz(IKON.karisik, sol + 20 * k, false);
    ikonCiz(IKON.geri, W / 2 - 200 * k, true);
    ikonCiz(IKON.ileri, W / 2 + 200 * k, true);
    ikonCiz(IKON.tekrar, sag - 20 * k, false);
    ctx.save();
    ctx.fillStyle = '#141414';
    ctx.beginPath(); ctx.arc(W / 2, cy, 78 * k, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = '#FFFFFF';
    ctx.beginPath(); ctx.moveTo(W / 2 - 22 * k, cy - 34 * k); ctx.lineTo(W / 2 + 36 * k, cy); ctx.lineTo(W / 2 - 22 * k, cy + 34 * k); ctx.closePath(); ctx.fill();
    ctx.restore();

    // Spotify kodu (vektör): 400 × 100 birimlik kod, 560 genişlikte
    var kw = 560 * k, kh = kw / 4, kodX = (W - kw) / 2, kodY = 1395 * k;
    if (d.kod) {
      var o = kw / 400;
      ctx.save();
      ctx.translate(kodX, kodY);
      ctx.scale(o, o);
      ctx.fillStyle = '#141414';
      d.kod.cubuklar.forEach(function (c) {
        ctx.beginPath();
        if (ctx.roundRect) ctx.roundRect(c.x, c.y, c.w, c.h, c.r); else ctx.rect(c.x, c.y, c.w, c.h);
        ctx.fill();
      });
      if (d.kod.logo) { ctx.translate(d.kod.logo.tx, d.kod.logo.ty); ctx.fill(new Path2D(d.kod.logo.d)); }
      ctx.restore();
    } else {
      ctx.save();
      ctx.setLineDash([12 * k, 10 * k]);
      ctx.strokeStyle = '#B9B4AA';
      ctx.lineWidth = 3 * k;
      ctx.strokeRect(kodX, kodY, kw, kh);
      ctx.setLineDash([]);
      ctx.fillStyle = '#8A857C';
      ctx.font = '600 ' + (26 * k) + 'px system-ui, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(d.kodYerTutucu || '', W / 2, kodY + kh / 2);
      ctx.restore();
    }
  }

  /* ---------- Doğum günü: bayraklar, konfeti, isim; parti şapkaları ---------- */
  var KONFETI_RENK = ['#FF7AA8', '#39C1E8', '#FFC23D', '#8B6CFF', '#4CD38F'];
  var KONFETI = [[9, 30, 0.9], [91, 24, 0.9], [84, 44, 0.8], [14, 50, 0.8], [90, 60, 0.7], [8, 70, 0.7], [4, 20, 0.6], [96, 34, 0.7], [94, 46, 0.6], [5, 42, 0.6], [16, 84, 0.7], [88, 80, 0.7], [3, 92, 0.6], [97, 94, 0.6]];
  var SERIT = [[12, 40, 20], [88, 34, -30], [93, 52, 40], [6, 58, -15], [95, 88, 60], [7, 80, 35], [86, 70, -40]];

  function dogumCiz(cv, d) {
    var W = cv.width, H = cv.height, k = W / 1100, s = W / 100;
    var ctx = cv.getContext('2d');
    ctx.fillStyle = '#FFF7EA';
    ctx.fillRect(0, 0, W, H);
    // Konfeti: noktalar ve kısa şeritler (konumlar posterin yüzdesi)
    KONFETI.forEach(function (c, i) {
      ctx.fillStyle = KONFETI_RENK[i % KONFETI_RENK.length];
      ctx.beginPath(); ctx.arc(c[0] * s, (c[1] / 100) * H, c[2] * s, 0, Math.PI * 2); ctx.fill();
    });
    SERIT.forEach(function (c, i) {
      ctx.save();
      ctx.translate(c[0] * s, (c[1] / 100) * H);
      ctx.rotate((c[2] * Math.PI) / 180);
      ctx.fillStyle = KONFETI_RENK[(i + 2) % KONFETI_RENK.length];
      ctx.fillRect(-1.6 * s, -0.45 * s, 3.2 * s, 0.9 * s);
      ctx.restore();
    });
    // Bayrak dizisi: sarkan ip boyunca üçgen bayraklar
    var ipY = function (t) { return (40 + 80 * 4 * t * (1 - t)) * k; };
    ctx.save();
    ctx.strokeStyle = '#3A2C5C'; ctx.lineWidth = 4 * k;
    ctx.beginPath(); ctx.moveTo(-10 * k, ipY(0)); ctx.quadraticCurveTo(W / 2, 200 * k, W + 10 * k, ipY(1)); ctx.stroke();
    for (var i = 0; i < 11; i++) {
      var t = (i + 0.5) / 11, bx = t * W, by = ipY(t) - 2 * k, en = 74 * k, boyb = 96 * k;
      ctx.fillStyle = KONFETI_RENK[i % KONFETI_RENK.length];
      ctx.beginPath(); ctx.moveTo(bx - en / 2, by); ctx.lineTo(bx + en / 2, by); ctx.lineTo(bx, by + boyb); ctx.closePath(); ctx.fill();
    }
    ctx.restore();
    // "iyi ki doğdun" + isim
    ctx.save();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#3A2C5C';
    ctx.font = '600 ' + (72 * k) + 'px "Fredoka", sans-serif';
    ctx.fillText(d.dogumUst || 'iyi ki doğdun', W / 2, 330 * k);
    ctx.fillStyle = '#E2477F';
    var ad = (d.dogumAd || '').trim();
    var adYazi = sigdir(ctx, ad ? ad + '!' : '', '', 158 * k, 70 * k, '"Shrikhand", cursive', W * 0.9);
    ctx.shadowColor = 'rgba(58,44,92,0.18)'; ctx.shadowOffsetY = 6 * k; ctx.shadowBlur = 0;
    ctx.fillText(adYazi, W / 2, 505 * k);
    ctx.restore();

    var yer = cikartmaYerlestir(ctx, W, H, k, d, 836, 700);
    // Şapkalar: yüz kutuları (sarılma görselinin piksellerinde) → çıkartma → poster
    if (yer && d.yuzler && d.cikartma && d.cikartma.donusum) {
      var dn = d.cikartma.donusum;
      var orta = d.yuzler.length > 1 ? (d.yuzler[0].originX + d.yuzler[0].width / 2 + d.yuzler[1].originX + d.yuzler[1].width / 2) / 2 : null;
      d.yuzler.forEach(function (b) {
        var px = function (gx) { return yer.x + ((gx * dn.o - dn.x0) + dn.r) * yer.olcek; };
        var py = function (gy) { return yer.y + ((gy * dn.o - dn.y0) + dn.r) * yer.olcek; };
        var sol = px(b.originX), sag = px(b.originX + b.width), ust = py(b.originY), alt = py(b.originY + b.height);
        var genis = (sag - sol) * 0.92, yuk = alt - ust;
        var merkez = b.originX + b.width / 2;
        var aci = orta === null ? 0 : (merkez < orta ? -16 : 16);
        sapkaCiz(ctx, (sol + sag) / 2 + (aci < 0 ? -0.06 : aci > 0 ? 0.06 : 0) * genis, ust - yuk * 0.32, genis, aci, d.yuzler.indexOf(b));
      });
    }
  }

  // Parti şapkası: taban ortası (x, y), taban genişliği, eğim (derece)
  function sapkaCiz(ctx, x, y, en, aci, sira) {
    var boy = en * 1.05, renk = sira % 2 ? ['#39C1E8', '#FFFFFF'] : ['#FF7AA8', '#FFFFFF'];
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate((aci * Math.PI) / 180);
    ctx.shadowColor = 'rgba(0,0,0,0.18)'; ctx.shadowOffsetY = en * 0.03; ctx.shadowBlur = en * 0.05;
    ctx.beginPath(); ctx.moveTo(-en / 2, 0); ctx.lineTo(en / 2, 0); ctx.lineTo(0, -boy); ctx.closePath();
    ctx.fillStyle = renk[0];
    ctx.fill();
    ctx.shadowColor = 'transparent';
    ctx.save();
    ctx.clip();
    ctx.fillStyle = renk[1];
    for (var i = 0; i < 4; i++) {
      var yy = -boy * (0.18 + i * 0.22);
      ctx.save(); ctx.translate(0, yy); ctx.rotate(-0.35); ctx.fillRect(-en, -en * 0.045, en * 2, en * 0.09); ctx.restore();
    }
    ctx.restore();
    ctx.fillStyle = '#FFC23D';
    ctx.beginPath(); ctx.arc(0, -boy, en * 0.12, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = '#FFFFFF';
    ctx.beginPath(); ctx.ellipse(0, 0, en * 0.54, en * 0.09, 0, 0, Math.PI * 2); ctx.fill();
    ctx.restore();
  }

  var CIZICILER = { klasik: klasikCiz, pastel: pastelCiz, sarki: sarkiCiz, dogum: dogumCiz };
  function posterCiz(cv, d) { (CIZICILER[d.tasarim] || klasikCiz)(cv, d); }

  // Görsel + şeffaf maske → beyaz kenarlı çıkartma (tuval). Maske yoksa yuvarlak köşeli fotoğraf.
  function cikartmaYap(gorsel, maske, azamiEn) {
    var o = Math.min(1, azamiEn / gorsel.naturalWidth);
    var w = Math.round(gorsel.naturalWidth * o), h = Math.round(gorsel.naturalHeight * o);
    var r = Math.max(4, Math.round(w * 0.012));
    var kirpX = 0, kirpY = 0;
    var kesik = document.createElement('canvas');
    kesik.width = w; kesik.height = h;
    var kc = kesik.getContext('2d');
    kc.drawImage(gorsel, 0, 0, w, h);
    if (maske) {
      kc.globalCompositeOperation = 'destination-in';
      kc.drawImage(maske, 0, 0, w, h);
    } else {
      kc.globalCompositeOperation = 'destination-in';
      kc.beginPath();
      if (kc.roundRect) kc.roundRect(0, 0, w, h, w * 0.04); else kc.rect(0, 0, w, h);
      kc.fill();
    }
    // Beyaz kenar: siluet her yöne r kadar kaydırılıp basılır, sonra beyaza boyanır. Üstte ve yanlarda r kadar pay var;
    // görsel tuvalin dibine oturur, böylece alt kenar (gövdelerin kesildiği yer) düz kalır.
    // Saydam kenarları kırp: model çocukları karede küçük çizse de çıkartma posterdeki alanı doldursun
    if (maske) {
      var veri = kc.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var yy = 0; yy < h; yy += 2) for (var xx = 0; xx < w; xx += 2) {
        if (veri[(yy * w + xx) * 4 + 3] > 40) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
      }
      if (x1 > x0 && y1 > y0) {
        x0 = Math.max(0, x0 - 2); y0 = Math.max(0, y0 - 2); x1 = Math.min(w - 1, x1 + 2); y1 = Math.min(h - 1, y1 + 2);
        var kw = x1 - x0 + 1, kh = y1 - y0 + 1;
        var kirp = document.createElement('canvas');
        kirp.width = kw; kirp.height = kh;
        kirp.getContext('2d').drawImage(kesik, x0, y0, kw, kh, 0, 0, kw, kh);
        kesik = kirp; w = kw; h = kh; kirpX = x0; kirpY = y0;
        r = Math.max(4, Math.round(w * 0.012));
      }
    }
    var son = document.createElement('canvas');
    son.width = w + r * 2; son.height = h + r;
    var sc = son.getContext('2d');
    for (var a = 0; a < 360; a += 15) {
      var rad = (a * Math.PI) / 180;
      sc.drawImage(kesik, r + Math.cos(rad) * r, r + Math.sin(rad) * r);
    }
    sc.globalCompositeOperation = 'source-in';
    sc.fillStyle = '#FFFFFF';
    sc.fillRect(0, 0, son.width, son.height);
    sc.globalCompositeOperation = 'source-over';
    sc.drawImage(kesik, r, r);
    // Sarılma görselindeki bir nokta (gx, gy) → çıkartmada ((gx·o − x0) + r, (gy·o − y0) + r): şapka yerleşimi için
    son.donusum = { o: o, x0: kirpX, y0: kirpY, r: r };
    return son;
  }

  // Spotify kodu SVG'si → çubuklar (yuvarlak köşeli dikdörtgenler) + logo yolu; postere vektör olarak çizilir
  async function kodAl(url) {
    var r = await fetch(url);
    if (!r.ok) throw new Error('kod alınamadı');
    var doc = new DOMParser().parseFromString(await r.text(), 'image/svg+xml');
    var cubuklar = Array.prototype.map.call(doc.querySelectorAll('rect'), function (e) {
      return { x: +e.getAttribute('x') || 0, y: +e.getAttribute('y') || 0, w: +e.getAttribute('width') || 0, h: +e.getAttribute('height') || 0, r: +(e.getAttribute('rx') || 0) };
    }).filter(function (c) { return c.w > 0 && c.w < 200; });
    var p = doc.querySelector('path'), logo = null;
    if (p) {
      var t = ((p.parentNode && p.parentNode.getAttribute && p.parentNode.getAttribute('transform')) || '').match(/translate\(\s*([\d.-]+)[\s,]+([\d.-]+)/);
      logo = { d: p.getAttribute('d'), tx: t ? +t[1] : 0, ty: t ? +t[2] : 0 };
    }
    if (!cubuklar.length) throw new Error('kod boş');
    return { cubuklar: cubuklar, logo: logo };
  }

  function resimYukle(src) {
    return new Promise(function (tamam, red) {
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function () { tamam(i); };
      i.onerror = function () { red(new Error('Görsel yüklenemedi')); };
      i.src = src;
    });
  }

  /* ---------- Stüdyo ---------- */
  var SIMGE = {
    yukle: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="9" r="1.8"/><path d="M21 15l-5-5L5 21"/></svg>',
    yukari: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>',
    tekrar: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M21 12a9 9 0 1 1-2.64-6.36"/><path d="M21 3v6h-6"/></svg>',
  };
  var METIN = {
    foto1: '1. kişinin çocukluk fotoğrafı',
    foto2: '2. kişinin çocukluk fotoğrafı',
    fotoAlt: 'Yüzün net göründüğü, tek başına çekilmiş bir fotoğraf',
    degistir: 'Değiştir',
    ad1: '1. isim', ad2: '2. isim',
    ad1Ornek: 'ELİF', ad2Ornek: 'EFE',
    soz: 'Söz',
    kendiSozum: 'Kendi sözümü yazacağım',
    sozOrnek: 'Sözünüzü yazın',
    yerTutucu: 'Fotoğraflar yüklenince burada sarılacaklar',
    tekrar: 'Tekrar dene',
    yukari: 'Posterin yukarıda, görmek için dokun',
    gorunum: 'Görünüm',
    gorunumPoster: 'Posterin',
    gorunumGaleri: 'Ürün fotoğrafları',
    denemeler: 'Denemelerin — beğendiğini seç',
    adimlar: ['Fotoğraflar inceleniyor', 'Çocukluğunuz bir araya getiriliyor', 'Sarılma anı hazırlanıyor', 'Çıkartma kesiliyor', 'Son rötuşlar yapılıyor'],
    sure: 'Yaklaşık 30 saniye sürer, sayfadan ayrılma.',
    yedek: 'Yoğunluk var, ikinci kez deneniyor…',
    hazir: 'Posterin hazır! İsimleri ve sözü dilediğin gibi değiştirebilirsin.',
    once: 'Önce iki çocukluk fotoğrafını yükle, posterin hazırlansın.',
    bekle: 'Posterin hazırlanıyor, birkaç saniye bekle.',
    baskiHazirlaniyor: 'Baskı dosyan hazırlanıyor…',
    baskiHata: 'Baskı dosyası gönderilemedi, lütfen tekrar dene.',
    acilamadi: 'Bu fotoğraf açılamadı. JPG veya PNG bir fotoğraf dene.',
    hata: 'Görsel şu an oluşturulamadı, lütfen tekrar dene.',
    uzun: 'Beklenenden uzun sürdü, lütfen tekrar dene.',
    spotify: 'Spotify şarkı linki',
    spotifyOrnek: 'open.spotify.com/track/…',
    spotifyYardim: 'Spotify\'da şarkının yanındaki ••• → Paylaş → Şarkı bağlantısını kopyala, buraya yapıştır.',
    spotifyAraniyor: 'Şarkı aranıyor…',
    spotifyBulundu: 'Bulundu:',
    spotifyHata: 'Bu linkte bir Spotify şarkısı bulunamadı.',
    spotifyOnce: 'Önce Spotify şarkı linkini yapıştır.',
    sanatci: 'Sanatçı adı',
    sanatciSpotify: 'Spotify\'daki sanatçı',
    sanatciKendi: 'Kendim yazacağım',
    sanatciOrnek: 'Furkan & Nehir',
    sarkiOrnek: 'Şarkınızın adı',
    kodYerTutucu: 'Spotify kodu burada olacak',
    dogumAd: 'Doğum günü olanın adı',
    dogumOrnek: 'NEHİR',
    dogumUst: 'iyi ki doğdun',
    hazirPastel: 'Posterin hazır! İsimleri dilediğin gibi değiştirebilirsin.',
    hazirSarki: 'Posterin hazır! Şarkıyı ve sanatçı adını dilediğin gibi değiştirebilirsin.',
    hazirDogum: 'Posterin hazır! İsmi dilediğin gibi değiştirebilirsin.',
    kvkk: 'Fotoğraflar yalnızca posterin için kullanılır; ara görseller 30 gün içinde silinir.',
    kvkkLink: 'Aydınlatma Metni',
    yapayZeka: 'Sarılma görseli iki fotoğraftan yapay zekâyla yeniden çizilir; yüzler fotoğraflara benzer, birebir aynı olmayabilir.',
  };
  // Tasarım başına görünen alan grupları, sipariş özellikleri, "hazır" mesajı ve siparişte görünen adı
  var TASARIM = {
    klasik: { gruplar: ['isimler', 'soz'], ozellik: ['_isimler', '_soz'], hazir: 'hazir', ad: 'Biz Daha Çocukken' },
    pastel: { gruplar: ['isimler'], ozellik: ['_isimler'], hazir: 'hazirPastel', ad: 'Pastel Boya' },
    sarki: { gruplar: ['sarki'], ozellik: ['_sarki', '_sanatci', '_spotify'], hazir: 'hazirSarki', ad: 'Bizim Şarkımız' },
    dogum: { gruplar: ['dogum'], ozellik: ['_isim'], hazir: 'hazirDogum', ad: 'Doğum Günü' },
  };
  var RENKLER = [[/beyaz|white/i, 'beyaz'], [/siyah|black/i, 'siyah'], [/ceviz|walnut/i, 'ceviz'], [/ah[sş]ap|naturel|wood|me[sş]e/i, 'ahsap'], [/alt[ıi]n|gold/i, 'altin']];
  function uyku(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function el(etiket, sinif, html) { var e = document.createElement(etiket); if (sinif) e.className = sinif; if (html != null) e.innerHTML = html; return e; }

  function Studyo(kok) {
    var ayarEl = kok.querySelector('[data-fso-cocuk-ayar]');
    var ayar = {};
    try { ayar = JSON.parse(ayarEl ? ayarEl.textContent : '{}'); } catch (e) { console.warn('[cocukluk] ayar okunamadı', e); }
    this.kok = kok;
    this.ayar = ayar;
    this.api = String(ayar.api || '').replace(/\/+$/, '');
    this.m = Object.assign({}, METIN, ayar.metinler || {});
    this.sozler = (ayar.sozler || []).map(function (z) { return String(z).trim(); }).filter(Boolean);
    if (!this.sozler.length) this.sozler = ['Bazı Ruhlar Evvelden Aşinadır Birbirlerine'];
    this.form = ayar.form ? document.querySelector(ayar.form) : kok.closest('form');
    this.sayfa = ayar.kok ? document.querySelector(ayar.kok) : document.body;
    this.medya = ayar.medya ? document.querySelector(ayar.medya) : null;
    this.tasarim = TASARIM[ayar.tasarim] ? ayar.tasarim : 'klasik';
    this.sarki = null;
    this.fotolar = [null, null];
    this.denemeler = [];
    this.secili = null;
    this.calisiyor = false;
    this.kur();
  }

  Studyo.prototype.kur = function () {
    var s = this, m = this.m;
    var kart = el('div', 'fso-cc');
    var radyo = 'fso-cc-sanatci-' + Math.random().toString(36).slice(2, 8);
    var sozSecenek = this.sozler.map(function (z, i) { return '<option value="' + i + '"></option>'; }).join('') + '<option value="kendi"></option>';
    kart.innerHTML =
      '<div class="fso-cc-fotolar">' +
        [0, 1].map(function (i) {
          return '<label class="fso-cc-foto" data-cc-foto="' + i + '">' +
            '<input type="file" accept="image/*" class="fso-cc-dosya" data-cc-dosya="' + i + '">' +
            '<span class="fso-cc-foto-bos"><span class="fso-cc-ikon">' + SIMGE.yukle + '</span><span class="fso-cc-foto-baslik"></span><span class="fso-cc-foto-alt"></span></span>' +
            '<img class="fso-cc-foto-img" alt="" hidden>' +
            '<span class="fso-cc-degistir" hidden></span>' +
          '</label>';
        }).join('') +
      '</div>' +
      '<div class="fso-cc-isimler" data-cc-grup="isimler">' +
        '<label class="fso-cc-alan"><span data-cc-et="ad1"></span><input type="text" maxlength="12" autocomplete="off" data-cc-ad="1"></label>' +
        '<label class="fso-cc-alan"><span data-cc-et="ad2"></span><input type="text" maxlength="12" autocomplete="off" data-cc-ad="2"></label>' +
      '</div>' +
      '<label class="fso-cc-alan" data-cc-grup="soz"><span data-cc-et="soz"></span><select data-cc-soz>' + sozSecenek + '</select></label>' +
      '<label class="fso-cc-alan" data-cc-kendi hidden><span class="fso-cc-gizli" data-cc-et="sozOrnek"></span><input type="text" maxlength="60" autocomplete="off" data-cc-kendi-soz></label>' +
      '<div class="fso-cc-sarki" data-cc-grup="sarki">' +
        '<label class="fso-cc-alan"><span data-cc-et="spotify"></span><input type="url" inputmode="url" autocomplete="off" spellcheck="false" data-cc-spotify></label>' +
        '<p class="fso-cc-yardim" data-cc-spotify-durum aria-live="polite"></p>' +
        '<div class="fso-cc-secim" role="radiogroup" data-cc-sanatci-secim><span class="fso-cc-secim-baslik" data-cc-et="sanatci"></span>' +
          '<label><input type="radio" name="' + radyo + '" value="spotify" checked><span data-cc-et="sanatciSpotify"></span></label>' +
          '<label><input type="radio" name="' + radyo + '" value="kendi"><span data-cc-et="sanatciKendi"></span></label>' +
        '</div>' +
        '<label class="fso-cc-alan" data-cc-sanatci-kutu hidden><span class="fso-cc-gizli" data-cc-et="sanatciOrnek"></span><input type="text" maxlength="40" autocomplete="off" data-cc-sanatci></label>' +
      '</div>' +
      '<label class="fso-cc-alan" data-cc-grup="dogum"><span data-cc-et="dogumAd"></span><input type="text" maxlength="14" autocomplete="off" data-cc-dogum></label>' +
      '<div class="fso-cc-slot" data-cc-slot></div>' +
      '<button type="button" class="fso-cc-yukari" data-cc-yukari hidden>' + SIMGE.yukari + '<span data-cc-et="yukari"></span></button>' +
      '<div class="fso-cc-ilerleme" data-cc-ilerleme hidden><div class="fso-cc-bar"><i data-cc-bar></i></div><p><strong data-cc-adim></strong><span data-cc-sure></span></p></div>' +
      '<div class="fso-cc-gecmis" data-cc-gecmis hidden><p data-cc-et="denemeler"></p><div class="fso-cc-kucukler" data-cc-kucukler role="radiogroup"></div></div>' +
      '<div class="fso-cc-eylem" data-cc-eylem hidden><button type="button" class="fso-btn fso-btn--secondary fso-cc-tekrar" data-cc-tekrar>' + SIMGE.tekrar + '<span></span></button></div>' +
      '<p class="fso-cc-mesaj" data-cc-mesaj role="status" aria-live="polite"></p>' +
      '<p class="fso-cc-not" data-cc-et="yapayZeka"></p>' +
      '<p class="fso-cc-not"><span data-cc-et="kvkk"></span>' + (this.ayar.kvkk ? ' <a target="_blank" rel="noopener" data-cc-kvkk></a>' : '') + '</p>';
    this.kok.appendChild(kart);
    this.kart = kart;
    this.$ = function (q) { return kart.querySelector(q); };
    this.$$ = function (q) { return kart.querySelectorAll(q); };

    // Metinler (textContent ile)
    this.$$('[data-cc-et]').forEach(function (e) { e.textContent = m[e.getAttribute('data-cc-et')] || ''; });
    this.$$('.fso-cc-foto').forEach(function (l, i) {
      l.querySelector('.fso-cc-foto-baslik').textContent = i ? m.foto2 : m.foto1;
      l.querySelector('.fso-cc-foto-alt').textContent = m.fotoAlt;
      l.querySelector('.fso-cc-degistir').textContent = m.degistir;
    });
    this.$('[data-cc-ad="1"]').placeholder = m.ad1Ornek;
    this.$('[data-cc-ad="2"]').placeholder = m.ad2Ornek;
    this.$('[data-cc-kendi-soz]').placeholder = m.sozOrnek;
    this.$('[data-cc-spotify]').placeholder = m.spotifyOrnek;
    this.$('[data-cc-spotify-durum]').textContent = m.spotifyYardim;
    this.$('[data-cc-sanatci]').placeholder = m.sanatciOrnek;
    this.$('[data-cc-dogum]').placeholder = m.dogumOrnek;
    var gruplar = TASARIM[this.tasarim].gruplar;
    this.$$('[data-cc-grup]').forEach(function (g) { g.hidden = gruplar.indexOf(g.getAttribute('data-cc-grup')) < 0; });
    kart.setAttribute('data-tasarim', this.tasarim);
    var secenekler = this.$('[data-cc-soz]').options;
    this.sozler.forEach(function (z, i) { secenekler[i].textContent = z; });
    secenekler[secenekler.length - 1].textContent = m.kendiSozum;
    this.$('[data-cc-tekrar] span').textContent = m.tekrar;
    this.$('[data-cc-sure]').textContent = m.sure;
    var kvkkA = this.$('[data-cc-kvkk]');
    if (kvkkA) { kvkkA.href = this.ayar.kvkk; kvkkA.textContent = m.kvkkLink; }

    // Sahne: çerçeveli poster önizlemesi
    var sahne = el('div', 'fso-cc-sahne');
    sahne.innerHTML = '<div class="fso-cc-duvar"><div class="fso-cc-cerceve" data-cc-cerceve><canvas class="fso-cc-tuval" data-cc-tuval width="660" height="960" role="img" aria-label="Poster önizlemesi"></canvas><div class="fso-cc-bekle" data-cc-bekle hidden><span data-cc-bekle-yazi></span></div></div></div>';
    this.sahne = sahne;
    this.tuval = sahne.querySelector('[data-cc-tuval]');
    // Ürün görselleri alanında: "Posterin" / "Ürün fotoğrafları" geçişi (önizleme varken de ürün fotoğraflarına bakılabilsin)
    var gorunumKutu = el('div', 'fso-cc-gorunum');
    gorunumKutu.setAttribute('role', 'group');
    gorunumKutu.setAttribute('aria-label', m.gorunum);
    gorunumKutu.innerHTML = '<button type="button" data-cc-gorunum="poster" aria-pressed="true"></button><button type="button" data-cc-gorunum="galeri" aria-pressed="false"></button>';
    gorunumKutu.querySelector('[data-cc-gorunum="poster"]').textContent = m.gorunumPoster;
    gorunumKutu.querySelector('[data-cc-gorunum="galeri"]').textContent = m.gorunumGaleri;
    gorunumKutu.querySelectorAll('[data-cc-gorunum]').forEach(function (b) {
      b.addEventListener('click', function () { s.gorunumSec(b.getAttribute('data-cc-gorunum')); });
    });
    // Not: "gecis" adı sepete ekleme denetiminin bayrağıdır (gonderiliyor); görünüm öğesi ayrı adla tutulur
    this.gorunumKutu = gorunumKutu;
    this.gorunum = 'poster';
    this.yerlestir();
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 1025px)');
      (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function () { s.yerlestir(); });
    }

    // Olaylar
    this.$$('[data-cc-dosya]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var i = +inp.getAttribute('data-cc-dosya');
        if (inp.files && inp.files[0]) s.fotoSec(i, inp.files[0]);
        inp.value = '';
      });
    });
    var onYukle = function () { algilayici(); yaziTipleriniYukle(); };
    ['pointerdown', 'focusin'].forEach(function (t) { kart.addEventListener(t, onYukle, { once: true, passive: true }); });
    this.$$('[data-cc-ad]').forEach(function (inp) { inp.addEventListener('input', function () { s.ciz(); }); });
    this.$('[data-cc-soz]').addEventListener('change', function () {
      s.$('[data-cc-kendi]').hidden = this.value !== 'kendi';
      s.ciz();
    });
    this.$('[data-cc-kendi-soz]').addEventListener('input', function () { s.ciz(); });
    var spotifyGirdi = this.$('[data-cc-spotify]'), spotifyBekle;
    spotifyGirdi.addEventListener('input', function () { clearTimeout(spotifyBekle); spotifyBekle = setTimeout(function () { s.spotifyAl(spotifyGirdi.value); }, 450); });
    spotifyGirdi.addEventListener('paste', function () { setTimeout(function () { clearTimeout(spotifyBekle); s.spotifyAl(spotifyGirdi.value); }, 0); });
    this.$$('[data-cc-sanatci-secim] input').forEach(function (r) {
      r.addEventListener('change', function () {
        var kendi = s.$('[data-cc-sanatci-secim] input[value="kendi"]').checked;
        s.$('[data-cc-sanatci-kutu]').hidden = !kendi;
        if (kendi) s.$('[data-cc-sanatci]').focus({ preventScroll: true });
        s.ciz();
      });
    });
    this.$('[data-cc-sanatci]').addEventListener('input', function () { s.ciz(); });
    this.$('[data-cc-dogum]').addEventListener('input', function () { s.ciz(); });
    this.$('[data-cc-tekrar]').addEventListener('click', function () { s.uret(); });
    this.$('[data-cc-yukari]').addEventListener('click', function () { s.gorunumSec('poster'); s.sahne.scrollIntoView({ behavior: 'smooth', block: 'center' }); });

    // Çerçeve rengi
    this.renkGuncelle();
    document.addEventListener('click', function (e) {
      if (s.ayar.renk && e.target.closest && e.target.closest(s.ayar.renk.replace(/\.selected\b/, ''))) requestAnimationFrame(function () { s.renkGuncelle(); });
    });

    // Sipariş özellikleri + sepete ekleme kapısı
    if (this.form) {
      this.girdiler = {};
      ['_tasarim_pdf', '_tasarim_onizleme', '_tasarim'].concat(TASARIM[this.tasarim].ozellik).forEach(function (ad) {
        var g = s.form.querySelector('input[name="properties[' + ad + ']"]');
        if (!g) { g = document.createElement('input'); g.type = 'hidden'; g.name = 'properties[' + ad + ']'; s.form.appendChild(g); }
        g.value = '';
        s.girdiler[ad] = g;
      });
      window.addEventListener('click', function (e) {
        var b = e.target && e.target.closest && e.target.closest('button[type="submit"], input[type="submit"]');
        if (b && b.form === s.form) s.gonderiliyor(e, b);
      }, true);
      window.addEventListener('submit', function (e) { if (e.target === s.form && !s.gecis) s.gonderiliyor(e, null); }, true);
    }

    yaziTipleriniYukle().then(function () { s.ciz(); });
    this.ciz();
  };

  // Önizleme her ekranda ürün görsellerinin yerinde durur (galeri gizlenir); medya alanı yoksa kartın içine düşer.
  // Mobilde kart sayfanın aşağısında kaldığı için kartta "posterin yukarıda" bağlantısı görünür.
  Studyo.prototype.yerlestir = function () {
    var medyada = !!this.medya;
    if (medyada) {
      if (this.medya.firstElementChild !== this.gorunumKutu) this.medya.insertBefore(this.gorunumKutu, this.medya.firstChild);
      if (this.gorunumKutu.nextElementSibling !== this.sahne) this.gorunumKutu.after(this.sahne);
    } else if (this.sahne.parentNode !== this.$('[data-cc-slot]')) {
      this.$('[data-cc-slot]').appendChild(this.sahne);
    }
    this.galeri = this.ayar.galeri ? document.querySelector(this.ayar.galeri) : null;
    this.gorunumKutu.hidden = !(medyada && this.galeri);
    this.$('[data-cc-yukari]').hidden = !medyada;
    this.gorunumSec(medyada ? this.gorunum : 'poster');
  };

  // "poster": önizleme görünür, ürün galerisi gizli; "galeri": ürün fotoğrafları görünür, önizleme gizli
  Studyo.prototype.gorunumSec = function (gorunum) {
    var medyada = !!this.medya && this.sahne.parentNode === this.medya;
    this.gorunum = medyada && this.galeri && gorunum === 'galeri' ? 'galeri' : 'poster';
    var galeride = this.gorunum === 'galeri';
    if (this.galeri) this.galeri.classList.toggle('fso-cc-gizle', medyada && !galeride);
    this.sahne.hidden = galeride;
    this.gorunumKutu.querySelectorAll('[data-cc-gorunum]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-cc-gorunum') === (galeride ? 'galeri' : 'poster')));
    });
  };

  Studyo.prototype.renkGuncelle = function () {
    var secili = this.ayar.renk ? document.querySelector(this.ayar.renk) : null;
    var deger = secili ? (secili.getAttribute('data-value') || secili.textContent || '') : '';
    var ad = 'siyah';
    for (var i = 0; i < RENKLER.length; i++) if (RENKLER[i][0].test(deger)) { ad = RENKLER[i][1]; break; }
    this.sahne.querySelector('[data-cc-cerceve]').setAttribute('data-renk', ad);
  };

  Studyo.prototype.durum = function () {
    var sec = this.$('[data-cc-soz]').value;
    var soz = sec === 'kendi' ? this.$('[data-cc-kendi-soz]').value.trim() : this.sozler[+sec];
    var sanatciKendi = this.$('[data-cc-sanatci-secim] input[value="kendi"]').checked;
    return {
      tasarim: this.tasarim,
      ad1: this.$('[data-cc-ad="1"]').value.trim() || this.m.ad1Ornek,
      ad2: this.$('[data-cc-ad="2"]').value.trim() || this.m.ad2Ornek,
      soz: this.tasarim === 'klasik' ? soz : '',
      sarki: this.sarki,
      sanatci: sanatciKendi ? (this.$('[data-cc-sanatci]').value.trim() || this.m.sanatciOrnek) : (this.sarki ? this.sarki.sanatci : ''),
      dogumAd: this.$('[data-cc-dogum]').value.trim() || this.m.dogumOrnek,
    };
  };

  // Çizim için durum + seçili denemenin görselleri + metinler
  Studyo.prototype.cizimVerisi = function (d, cikartma) {
    var sec = this.secili, m = this.m;
    return Object.assign({}, d, {
      cikartma: cikartma || (sec ? sec.onizlemeCikartma : null),
      kapak: sec ? sec.gorsel : null,
      yuzler: sec ? sec.yuzler : null,
      kod: d.sarki ? d.sarki.kod : null,
      yerTutucu: m.yerTutucu, sarkiOrnek: m.sarkiOrnek, kodYerTutucu: m.kodYerTutucu, dogumUst: m.dogumUst,
    });
  };

  Studyo.prototype.ciz = function () {
    var d = this.durum();
    posterCiz(this.tuval, this.cizimVerisi(d));
    if (this.girdiler && this.secili) this.ozellikYaz(d);
  };

  Studyo.prototype.ozellikYaz = function (d) {
    var g = this.girdiler, ata = function (ad, v) { if (g[ad]) g[ad].value = v || ''; };
    ata('_tasarim', TASARIM[this.tasarim].ad);
    ata('_isimler', d.ad1 + ' ♥ ' + d.ad2);
    ata('_soz', d.soz);
    ata('_sarki', d.sarki ? d.sarki.ad + ' (' + d.sarki.sure + ')' : '');
    ata('_sanatci', d.sanatci);
    ata('_spotify', d.sarki ? 'https://open.spotify.com/track/' + d.sarki.id : '');
    ata('_isim', d.dogumAd);
  };

  // Spotify linki → şarkı bilgisi + kod (sunucu /spotify); son yazılan link kazanır
  Studyo.prototype.spotifyAl = async function (deger) {
    var v = String(deger || '').trim(), durum = this.$('[data-cc-spotify-durum]');
    if (this.sarki && this.sarki.girdi === v) return;
    var sira = (this.spotifySira = (this.spotifySira || 0) + 1);
    durum.classList.remove('is-error');
    if (!v) { this.sarki = null; durum.textContent = this.m.spotifyYardim; this.ciz(); return; }
    durum.textContent = this.m.spotifyAraniyor;
    try {
      var b = await this.istek('/spotify?u=' + encodeURIComponent(v));
      var kod = await kodAl(b.kod);
      if (sira !== this.spotifySira) return;
      this.sarki = { girdi: v, id: b.id, uri: b.uri, ad: b.ad, sanatci: b.sanatci, sureMs: b.sureMs, sure: b.sure, kod: kod };
      durum.textContent = this.m.spotifyBulundu + ' ' + b.ad + ' — ' + b.sanatci + ' · ' + b.sure;
    } catch (e) {
      if (sira !== this.spotifySira) return;
      console.warn('[cocukluk] spotify', e);
      this.sarki = null;
      durum.textContent = e && e.sunucu ? e.message : this.m.spotifyHata;
      durum.classList.add('is-error');
    }
    this.ciz();
  };

  // Doğum günü şapkaları için sarılma görselindeki yüzler (en büyük iki yüz, soldan sağa)
  Studyo.prototype.yuzBul = async function (deneme) {
    try {
      var fd = await zamanAsimi(algilayici(), 15000);
      var w = deneme.gorsel.naturalWidth;
      deneme.yuzler = (fd.detect(deneme.gorsel).detections || []).map(function (x) { return x.boundingBox; })
        .filter(function (b) { return b.width > w * 0.06; })
        .sort(function (a, b) { return b.width * b.height - a.width * a.height; }).slice(0, 2)
        .sort(function (a, b) { return a.originX - b.originX; });
      if (this.secili === deneme) this.ciz();
    } catch (e) {
      console.warn('[cocukluk] şapka için yüz bulunamadı', e);
    }
  };

  Studyo.prototype.mesaj = function (t, tur) {
    var p = this.$('[data-cc-mesaj]');
    p.textContent = t || '';
    p.classList.toggle('is-error', tur === 'hata');
  };

  Studyo.prototype.fotoSec = async function (i, dosya) {
    if (this.calisiyor) { this.mesaj(this.m.bekle); return; }
    if (!/^image\//.test(dosya.type || 'image/')) { this.mesaj(this.m.acilamadi, 'hata'); return; }
    var etiket = this.$('[data-cc-foto="' + i + '"]');
    try {
      var h = await fotoHazirla(dosya);
      if (this.fotolar[i] && this.fotolar[i].url) URL.revokeObjectURL(this.fotolar[i].url);
      this.fotolar[i] = h;
      var img = etiket.querySelector('.fso-cc-foto-img');
      img.src = h.veri;
      img.hidden = false;
      etiket.querySelector('.fso-cc-foto-bos').hidden = true;
      etiket.querySelector('.fso-cc-degistir').hidden = false;
      etiket.classList.add('is-dolu');
      this.mesaj('');
    } catch (e) {
      console.warn('[cocukluk]', e);
      this.mesaj(this.m.acilamadi, 'hata');
      return;
    }
    if (this.fotolar[0] && this.fotolar[1]) this.uret();
  };

  Studyo.prototype.istek = async function (yol, secenek) {
    var r = await fetch(this.api + yol, secenek || {});
    var veri = await r.json().catch(function () { return {}; });
    if (!r.ok) { var h = new Error(veri.hata || this.m.hata); h.sunucu = !!veri.hata; throw h; }
    return veri;
  };

  Studyo.prototype.uret = async function () {
    if (!this.fotolar[0] || !this.fotolar[1]) { this.mesaj(this.m.once, 'hata'); return; }
    if (this.calisiyor) return;
    this.calisiyor = true;
    this.mesaj('');
    this.$('[data-cc-tekrar]').disabled = true;
    this.ilerleme(true);
    var bas = Date.now();
    try {
      var r = await this.istek('/cocuk/uret', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ foto1: this.fotolar[0].veri, foto2: this.fotolar[1].veri }) });
      var d;
      for (;;) {
        await uyku(2000);
        d = await this.istek('/cocuk/durum/' + r.id);
        this.yedekte = !!d.yedek;
        if (d.durum === 'hazir') break;
        if (d.durum === 'hata') throw new Error(this.m.hata);
        if (Date.now() - bas > 180000) throw new Error(this.m.uzun);
      }
      var gorsel = await resimYukle(d.gorsel);
      var maske = d.maske ? await resimYukle(d.maske).catch(function () { return null; }) : null;
      var deneme = { id: r.id, gorsel: gorsel, maske: maske, onizlemeCikartma: cikartmaYap(gorsel, maske, 700) };
      this.denemeler.push(deneme);
      this.sec(deneme);
      if (this.tasarim === 'dogum') this.yuzBul(deneme);
      this.mesaj(this.m[TASARIM[this.tasarim].hazir]);
    } catch (e) {
      console.warn('[cocukluk]', e);
      this.mesaj(e && (e.sunucu || e.message === this.m.uzun) ? e.message : this.m.hata, 'hata');
    } finally {
      this.calisiyor = false;
      this.ilerleme(false);
      this.$('[data-cc-tekrar]').disabled = false;
      this.$('[data-cc-eylem]').hidden = false;
    }
  };

  Studyo.prototype.sec = function (deneme) {
    this.secili = deneme;
    this.gorunumSec('poster');
    this.ciz();
    var s = this, kutu = this.$('[data-cc-kucukler]');
    this.$('[data-cc-gecmis]').hidden = this.denemeler.length < 2;
    kutu.innerHTML = '';
    this.denemeler.forEach(function (d, i) {
      var b = el('button', 'fso-cc-kucuk');
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', String(d === s.secili));
      b.setAttribute('aria-label', (i + 1) + '. deneme');
      var c = document.createElement('canvas');
      c.width = 120; c.height = Math.round(120 * d.gorsel.naturalHeight / d.gorsel.naturalWidth);
      c.getContext('2d').drawImage(d.gorsel, 0, 0, c.width, c.height);
      b.appendChild(c);
      b.addEventListener('click', function () { s.sec(d); });
      kutu.appendChild(b);
    });
    if (window.matchMedia && !window.matchMedia('(min-width: 1025px)').matches) {
      var r = this.sahne.getBoundingClientRect();
      if (r.top < 110 || r.bottom > window.innerHeight - 90) this.sahne.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  Studyo.prototype.ilerleme = function (acik) {
    var s = this, kutu = this.$('[data-cc-ilerleme]'), bar = this.$('[data-cc-bar]'), adim = this.$('[data-cc-adim]');
    var bekle = this.sahne.querySelector('[data-cc-bekle]'), bekleYazi = this.sahne.querySelector('[data-cc-bekle-yazi]');
    clearInterval(this.sayac);
    kutu.hidden = !acik;
    bekle.hidden = !acik;
    if (!acik) return;
    var bas = Date.now(), adimlar = this.m.adimlar;
    this.yedekte = false;
    var tik = function () {
      var t = (Date.now() - bas) / 1000;
      bar.style.width = (Math.min(0.95, 1 - Math.exp(-t / 12)) * 100).toFixed(1) + '%';
      var metin = s.yedekte ? s.m.yedek : adimlar[Math.min(adimlar.length - 1, Math.floor(t / 6))];
      adim.textContent = metin;
      bekleYazi.textContent = metin;
    };
    tik();
    this.sayac = setInterval(tik, 300);
  };

  // Sepete ekle: tasarım yoksa durdur; varsa tam çözünürlüklü baskıyı gönder, özellikleri yaz, sonra eklemeye devam et
  Studyo.prototype.gonderiliyor = function (e, dugme) {
    if (this.gecis) return;
    var durdur = function () { e.preventDefault(); e.stopImmediatePropagation(); };
    if (this.calisiyor) { durdur(); this.mesaj(this.m.bekle); this.goster(); return; }
    if (!this.secili) { durdur(); this.mesaj(this.m.once, 'hata'); this.goster(); return; }
    var d = this.durum();
    if (this.tasarim === 'sarki' && !this.sarki) {
      durdur();
      this.mesaj(this.m.spotifyOnce, 'hata');
      this.goster();
      this.$('[data-cc-spotify]').focus({ preventScroll: true });
      return;
    }
    var anahtar = this.secili.id + '|' + JSON.stringify([d.tasarim, d.ad1, d.ad2, d.soz, d.sarki && d.sarki.id, d.sanatci, d.dogumAd]);
    if (this.gonderilen === anahtar && this.girdiler._tasarim_pdf.value) return; // aynı tasarım zaten gönderildi
    durdur();
    if (this.gonderiyor) return;
    this.baskiGonder(anahtar, d, dugme || this.form.querySelector('button[type="submit"]'));
  };

  Studyo.prototype.baskiGonder = async function (anahtar, d, dugme) {
    var s = this;
    this.gonderiyor = true;
    this.mesaj(this.m.baskiHazirlaniyor);
    if (dugme) { dugme.disabled = true; dugme.setAttribute('aria-busy', 'true'); }
    try {
      await yaziTipleriniYukle();
      var baski = document.createElement('canvas');
      baski.width = 2400; baski.height = 3491;
      posterCiz(baski, this.cizimVerisi(d, cikartmaYap(this.secili.gorsel, this.secili.maske, 1800)));
      var kucuk = document.createElement('canvas');
      kucuk.width = 600; kucuk.height = 873;
      kucuk.getContext('2d').drawImage(baski, 0, 0, 600, 873);
      var blob = function (c, q) { return new Promise(function (tamam) { c.toBlob(tamam, 'image/jpeg', q); }); };
      var fd = new FormData();
      fd.append('baski', await blob(baski, 0.9), 'baski.jpg');
      fd.append('onizleme', await blob(kucuk, 0.85), 'onizleme.jpg');
      var r = await this.istek('/cocuk/baski/' + this.secili.id, { method: 'POST', body: fd });
      this.girdiler._tasarim_pdf.value = r.pdf;
      this.girdiler._tasarim_onizleme.value = r.onizleme;
      this.ozellikYaz(d);
      this.gonderilen = anahtar;
      this.mesaj('');
      if (dugme) { dugme.disabled = false; dugme.removeAttribute('aria-busy'); }
      this.gecis = true;
      try { if (dugme) dugme.click(); else s.form.requestSubmit(); } finally { this.gecis = false; }
    } catch (e) {
      console.warn('[cocukluk] baskı', e);
      this.mesaj(this.m.baskiHata, 'hata');
      if (dugme) { dugme.disabled = false; dugme.removeAttribute('aria-busy'); }
    } finally {
      this.gonderiyor = false;
    }
  };

  Studyo.prototype.goster = function () {
    var kart = this.kok.closest('[data-fso-custom]') || this.kok;
    var ofset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--fso-header-sticky-h'), 10) || 0;
    window.scrollTo({ top: Math.max(0, kart.getBoundingClientRect().top + window.scrollY - ofset - 12), behavior: 'smooth' });
    kart.classList.remove('is-need');
    void kart.offsetWidth;
    kart.classList.add('is-need');
  };

  function baslat() {
    document.querySelectorAll('[data-fso-cocuk]').forEach(function (k) {
      if (k.__fsoCocuk) return;
      k.__fsoCocuk = new Studyo(k);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
  window.FsoCocukluk = { baslat: baslat, posterCiz: posterCiz, cikartmaYap: cikartmaYap }; // cikartmaYap: mockup/baskı üretimi için
})();
